import ApiService from '../../services/api.service';
import asyncWrapper from '../../utils/asyncWrapper';
import {
  SNACKBAR,
  ERROR_SNACKBAR,
  SET_LOADING_OVERLAY,
  SET_SSH_KEYS
} from '../mutation-types';

const state = {
  isLoadingOverlay: false,
  SSHKeys: []
}

const getters = {
  isLoadingOverlay (state) {
    return state.isLoadingOverlay
  },
  SSHKeys (state) {
    return state.SSHKeys
  }
}

const actions = {
  async addSSHKey({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('settings/ssh', data));
    
    !error ? commit(SNACKBAR, 'SSH key added successfully!') : commit(ERROR_SNACKBAR, error.response.data.error);
    

    return { error, result }
  },
  async getSSHKeys({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('settings/ssh'));
    
    return !error ? commit(SET_SSH_KEYS, result) : commit(ERROR_SNACKBAR, error.response.data.error);
  },
  async deleteSSHKey({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.put('settings/ssh', data));

    !error ? commit(SNACKBAR, 'SSH key has been deleted successfully!') : commit(ERROR_SNACKBAR, error.response.data.error);
    
    return { error, result }
  },
  changeLoadingState({ commit }) {
    commit(SET_LOADING_OVERLAY);
  }
}

const mutations = {
  [SET_LOADING_OVERLAY] (state) {
    state.isLoadingOverlay = !state.isLoadingOverlay
  },
  [SET_SSH_KEYS] (state, payload) {
    state.SSHKeys = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

